import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { HttpClient } from '@angular/common/http';
import { BrandsMenu, IPaginateResult, IPagination, ListFavorites, ListProduct, PaginationFilters, Product } from '../../interfaces';

@Injectable({
    providedIn: 'root'
})
export class ProductsService {
    private path = environment.apiUrl;
    constructor(private http: HttpClient) {}

    getAll(payload: IPagination) {
        return this.http.post<IPaginateResult<ListProduct>>(`${this.path}/luxura-products/catalogue`, payload);
    }
    getOne(payload: string) {
        return this.http.get<Product>(`${this.path}/luxura-products/catalogue/${payload}`);
    }
    getBrands() {
        return this.http.get<BrandsMenu>(`${this.path}/luxura-products/brands`);
    }
    getBrandsWithSearch(payload: string) {
        return this.http.post<BrandsMenu>(`${this.path}/luxura-products/get-brands`, { search: payload });
    }

    getBrandsForSellNow(payload: string) {
        return this.http.post<BrandsMenu>(`${this.path}/sell-now/get-brands`, { search: payload });
    }

    getStandardFilters() {
        return this.http.get<PaginationFilters>(`${this.path}/luxura-products/standard-filters`);
    }
    getMyFavorites(payload: IPagination) {
        return this.http.post<IPaginateResult<ListFavorites>>(`${this.path}/luxura-products/my-likes`, payload);
    }
    toggleFav(id: string) {
        return this.http.patch<Product>(`${this.path}/luxura-products/user/likes/${id}`, {});
    }
}
